

import React, { useEffect, useRef, useState } from 'react';
import $ from 'jquery';
import { registerLocale } from "react-datepicker";
import * as R from 'ramda';
import contriesList from 'iso-3166-1-alpha-2';
import fr from "date-fns/locale/fr";
import liendirect from './../../../../assets/images/svg/049-family.svg';
import autres from './../../../../assets/images/svg/051-parents.svg';
import { useDispatch, useSelector } from 'react-redux';
import {RegexFields} from '../../../../constants/utils/regexFields';
import {DateWithModal} from '../../../../_common/dateWithModal';
import { PostalCityInput } from "../../../../_common/postalCityInput";
import * as loadings from '../../../../constants/loadings/facilita/deathDeclaration';
import {DeleteModal} from './deleteModal';
import countryTelData from 'country-telephone-data';
import parsePhoneNumber from 'libphonenumber-js';
import {AsYouType} from 'libphonenumber-js/max';

import {createUserRepresentativeForUserId, updateUserRepresentativeForUserId, deleteUserRepresentativeForUserId} from '../../../../actions/facilita-api';
 

export const EditView = ({ referent, referentId, toggleEditMode, removeFromList, userId, isLoading }) => {
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));

    registerLocale("fr", fr);
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();
    const [wasValidated, setWasValidated] = useState(false);
    const isNew = false;

    //#region form
    const referentForm = useRef(null);
    const gender = { male: 2, female: 1 };
    const representativeType = {child: 1, parent:2, sibling:3, spouse:4, other:5};


    let initState = {...referent, isLienFamilialDirect: referent.representativeType < 5};
    if(R.isNil(referent.phoneNumber) || referent.phoneNumber === ""){
        initState.phoneCountry = "FR";
        initState.countryCode = "33";
    }else{
        let phone = parsePhoneNumber(referent.phoneNumber);
        initState.phoneNumber = phone.nationalNumber;
        initState.countryCode = phone.countryCallingCode;
        initState.phoneCountry = phone.country;
    }
    initState.asYouType = new AsYouType(initState.phoneCountry);
    
    const [referentData, setReferentData] = useState(initState);


    useEffect(() => {
        //fillCredentials();
        $('[data-toggle="tooltip"]').tooltip();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    //#endregion
    return (
			<div className={"card card-body pb-0 shadow mb-4"}>
				{isNew === true ? (
					""
				) : (
					<h2 className="h4 text-secondary font-weight-bolder mt-2 mb-3">
						{referentData.isMainRepresentative === true ? "" : "AUTRE"} RÉFÉRENT {referentData.isMainRepresentative === true ? "PRINCIPAL *" : ""}
					</h2>
				)}
				{referentData.isMainRepresentative === true ? (
					<React.Fragment>
						<p className="h5 o-80 lh-copy mb-4">Votre Référent Principal est la personne qui aura accès et qui validera l’envoi des courriers obligatoires le moment venu.</p>
						<p className="h5 o-80 lh-copy">Le Référent sera averti par mail et par SMS annuellement de votre démarche mais n’aura pas accès aux informations de votre dossier (comptes bancaires, contrats d’assurances...).</p>
						<hr className="my-3" />
					</React.Fragment>
				) : (
					""
				)}
				<form className={"py-sm"} noValidate ref={referentForm}>
					<div className="form-row mb-3">
						<div className="form-group col-12 col-sm">
							<label className="h6 font-weight-bolder my-auto" htmlFor={"Email" + referentId}>
								Email
							</label>
							<input
								type="email"
								className="form-control"
								id={"Email" + referentId}
								defaultValue={referentData.email}
								onChange={(event) => {
									setReferentData({ ...referentData, email: event.target.value });
								}}
								pattern={RegexFields.email}
							/>
						</div>
					</div>

					<div className="form-group container-copy">
						<label className="h6 font-weight-bolder my-auto" htmlFor={"Telephone" + referentId}>
							Numéro de portable
						</label>
						<div className="input-group mb-0">
							<select
								className="custom-select rounded container-tiny mr-2"
								id={"phonecode" + referentId}
								tabIndex={-98}
								value={referentData.countryCode}
								onChange={(event) => {
									let pc = countryTelData.allCountryCodes[event.target.value][0].toUpperCase();
									setReferentData({ ...referentData, countryCode: event.target.value, asYouType: new AsYouType(pc), phoneCountry: pc });
								}}>
								{countryTelData.allCountries.map((country, index) => {
									let dialCode = country.dialCode;
									return (
										<option key={index} value={dialCode}>
											{countries.getName(country.iso2, "fr", { select: "official" })} (+{dialCode})
										</option>
									);
								})}
							</select>
							<input
								type="tel"
								className="form-control rounded"
								id={"phone" + referentId}
								value={parsePhoneNumber(referentData.phoneNumber, referentData.phoneCountry) !== undefined ? parsePhoneNumber(referentData.phoneNumber, referentData.phoneCountry).formatNational() : referentData.phoneNumber}
								aria-describedby="telephoneHelpBlock"
								onChange={(e) => setReferentData({ ...referentData, phoneNumber: e.target.value })}
							/>

							{/* <Input required className="form-control rounded" id={"phone" + referentId} international value={"+" + referentData.countryCode + referentData.phoneNumber} country={referentData.phoneCountry} onChange={ (value) => setReferentData({ ...referentData, phoneNumber: "+"+referentData.countryCode + value})} /> */}
							{/* <input required type="tel" className="form-control rounded" id={"phone" + referentId} placeholder="00 00 00 00 00" value={referentData.phoneNumber} aria-describedby="telephoneHelpBlock"
                            onInput={(e) => {
                                e.preventDefault();
                                e.target.value = e.target.value.replace(/ /g, '');                                
                                var number = referentData.countryCode === "+33" ? e.target.value.replace(/\B(?=(\d{2})+(?!\d))/g, " ") : e.target.value.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                                setReferentData({ ...referentData, phoneNumber: number.replace(/\B(?=(\d{3})+(?!\d))/g, " ") });
                            }} /> */}
						</div>
					</div>

					<div className="form-inline mb-3">
						<div className="custom-control custom-radio custom-control-inline mr-6">
							<input
								required
								type="radio"
								id={"Madame" + referentId}
								name="SexMadameMonsieur"
								className="custom-control-input"
								defaultChecked={referentData.gender === gender.female}
								onClick={(e) => {
									setReferentData({ ...referentData, gender: gender.female });
								}}
							/>
							<label className="custom-control-label" htmlFor={"Madame" + referentId}>
								Madame
							</label>
						</div>
						<div className="custom-control custom-radio custom-control-inline">
							<input
								type="radio"
								id={"Monsieur" + referentId}
								name="SexMadameMonsieur"
								className="custom-control-input"
								defaultChecked={referentData.gender === gender.male}
								onClick={(e) => {
									setReferentData({ ...referentData, gender: gender.male });
								}}
							/>
							<label className="custom-control-label" htmlFor={"Monsieur" + referentId}>
								Monsieur
							</label>
						</div>
					</div>
					<div className="form-row">
						<div className="form-group col-12 col-sm-6 col-xl">
							<label className="h6 font-weight-bolder my-auto" htmlFor={"Prenom" + referentId}>
								Prénom
							</label>
							<input
								required
								type="text"
								className="form-control"
								id={"Prenom" + referentId}
								value={referentData.firstName}
								onChange={(e) => {
									e.preventDefault();
									setReferentData({ ...referentData, firstName: e.target.value });
								}}
								pattern={RegexFields.nameWithoutNumbers}
							/>
						</div>
						<div className="form-group col-12 col-sm-6 col-xl">
							<label className="h6 font-weight-bolder my-auto" htmlFor={"Nom" + referentId}>
								Nom
							</label>
							<input
								required
								type="text"
								className="form-control"
								id={"Nom" + referentId}
								value={referentData.lastName}
								onChange={(e) => {
									e.preventDefault();
									setReferentData({ ...referentData, lastName: e.target.value });
								}}
								pattern={RegexFields.nameWithoutNumbers}
							/>
						</div>

						<div className="form-group col-12 col-sm col-lg-auto col-xl">
							<label className="h6 font-weight-bolder my-auto" htmlFor={"naissance" + referentId}>
								Date de naissance
							</label>
							<DateWithModal isRequired={true} selectedDate={referentData.birthDate} setSelectedDate={(d) => setReferentData({ ...referentData, birthDate: d })} />
						</div>
					</div>
					<div className="form-row">
						<div className="form-group col-12 col-sm">
							<label className="h6 font-weight-bolder my-auto" htmlFor={"Adresse" + referentId}>
								Adresse
							</label>
							<input
								required
								type="text"
								className="form-control"
								id={"Adresse" + referentId}
								value={referentData.addresses[0].addressLine1}
								onChange={(event) => {
									setReferentData({ ...referentData, addresses: [{ ...referentData.addresses[0], addressLine1: event.target.value }] });
								}}
							/>
						</div>
					</div>
					<div className="form-row">
						<PostalCityInput
							postalCode={referentData.addresses[0].postalCode}
							city={referentData.addresses[0].city}
							onChange={(updatedAddress) => setReferentData({ ...referentData,  addresses: [{ ...referentData.addresses[0], postalCode: updatedAddress.postalCode, city: updatedAddress.city }] })}
							hasWrapper={false}
							country={referentData.addresses[0].country}
							customClasses={{ city: "form-group col-12 col-sm col-xl", postalCode: "form-group col-12 col-sm col-xl" }}
						/>
						{/* <div className="form-group col-12 col-sm col-xl">
							<label className="h6 font-weight-bolder my-auto" htmlFor={"Postal" + referentId}>
								Code Postal
							</label>
							{referentData.country === null || referentData.country === "FR" || referentData.country === "GF" || referentData.country === "PF" || referentData.country === "TF" ? (
								<input
									required
									type="text"
									className="form-control"
									id={"Postal" + referentId}
									value={referentData.addresses[0].postalCode}
									onChange={(event) => {
										setReferentData({ ...referentData, addresses: [{ ...referentData.addresses[0], postalCode: event.target.value }] });
									}}
									pattern={RegexFields.frenchZipCode}
								/>
							) : (
								<input
									required
									type="text"
									className="form-control"
									id={"Postal" + referentId}
									value={referentData.addresses[0].postalCode}
									onChange={(event) => {
										setReferentData({ ...referentData, addresses: [{ ...referentData.addresses[0], postalCode: event.target.value }] });
									}}
								/>
							)}
						</div>
						<div className="form-group col-12 col-sm col-xl">
							<label className="h6 font-weight-bolder my-auto" htmlFor={"Ville" + referentId}>
								Ville
							</label>
							<input
								required
								type="text"
								className="form-control"
								id={"Ville" + referentId}
								value={referentData.addresses[0].city}
								onChange={(event) => {
									setReferentData({ ...referentData, addresses: [{ ...referentData.addresses[0], city: event.target.value }] });
								}}
								pattern={RegexFields.nameWithoutNumbers}
							/>
						</div> */}
					</div>
					<div className="form-row">
						<div className="form-group col-12 col-sm col-xl">
							<label className="h6 font-weight-bolder my-auto" htmlFor={"naturalite" + referentId}>
								Pays *
							</label>
							<select
								className="custom-select"
								id={"naturalite" + referentId}
								tabIndex={-98}
								value={referentData.addresses[0].country}
								onChange={(event) => {
									setReferentData({ ...referentData, addresses: [{ ...referentData.addresses[0], country: event.target.value }] });
								}}>
								{Object.keys(contriesList.getData()).map((country, index) => {
									return (
										<option key={index} value={country}>
											{countries.getName(country, "fr", { select: "official" })}
										</option>
									);
								})}
							</select>
						</div>
					</div>
					<div className="form-group">
						<label className="h6 font-weight-bolder" htmlFor={"ref" + referentId}>
							Le référent est:
						</label>
						<div className="form-row">
							<div className="form-group col-12 col-sm mb-2">
								<div
									className={"card px-3 py-2 border-faded text-capitalize picker-card flex-row align-items-center" + (referentData.isLienFamilialDirect === true ? " active" : "")}
									name={"ref" + referentId}
									onClick={() => {
										setReferentData({ ...referentData, isLienFamilialDirect: true, representativeType: undefined });
									}}>
									<img className="img-fluid my-auto mb-2 h-5 w-5 py-1" src={liendirect} alt="lien familial direct" />
									<h2 className="h6 font-weight-bolder ml-2 pl-1 mb-0 text-uppercase">lien familial direct</h2>
								</div>
							</div>
							<div className="form-group col-12 col-sm mb-2">
								<div
									className={"card px-3 py-2 border-faded text-capitalize picker-card flex-row align-items-center" + (referentData.representativeType === representativeType.other ? " active" : "")}
									name={"ref" + referentId}
									onClick={() => {
										setReferentData({ ...referentData, representativeType: representativeType.other, isLienFamilialDirect: false });
									}}>
									<img className="img-fluid my-auto mb-2 h-5 w-5 py-1" src={autres} alt="autres" />
									<h2 className="h6 font-weight-bolder ml-2 pl-1 mb-0 text-uppercase">autres</h2>
								</div>
							</div>
						</div>
						{referentData.isLienFamilialDirect === true ? (
							<div className="form-group">
								<label className="h6 font-weight-bolder text-uppercase" htmlFor="processus">
									TYPE DE lien
								</label>
								<div className="form-inline mb-3">
									<div
										className="custom-control custom-radio custom-control-inline"
										onClick={() => {
											setReferentData({ ...referentData, representativeType: representativeType.child });
										}}>
										<input required type="radio" id="FilsFille" name="relationship" className="custom-control-input" defaultChecked={referentData.representativeType === representativeType.child} />
										<label className="custom-control-label" htmlFor="FilsFille">
											Fils/Fille
										</label>
									</div>
									<div
										className="custom-control custom-radio custom-control-inline"
										onClick={() => {
											setReferentData({ ...referentData, representativeType: representativeType.parent });
										}}>
										<input type="radio" id="Parent" name="relationship" className="custom-control-input" defaultChecked={referentData.representativeType === representativeType.parent} />
										<label className="custom-control-label" htmlFor="Parent">
											Parent
										</label>
									</div>
									<div
										className="custom-control custom-radio custom-control-inline"
										onClick={() => {
											setReferentData({ ...referentData, representativeType: representativeType.sibling });
										}}>
										<input type="radio" id="FrèreSoeur" name="relationship" className="custom-control-input" defaultChecked={referentData.representativeType === representativeType.sibling} />
										<label className="custom-control-label" htmlFor="FrèreSoeur">
											Frère/Soeur
										</label>
									</div>
									<div
										className="custom-control custom-radio custom-control-inline"
										onClick={() => {
											setReferentData({ ...referentData, representativeType: representativeType.spouse });
										}}>
										<input type="radio" id="Conjoint" name="relationship" className="custom-control-input" defaultChecked={referentData.representativeType === representativeType.spouse} />
										<label className="custom-control-label" htmlFor="Conjoint">
											Conjoint
										</label>
									</div>
								</div>
							</div>
						) : (
							""
						)}
						<div className={"invalid-feedback alert-danger alert" + (referentData.representativeType === undefined && wasValidated === true ? " d-block" : "")}>Veuillez choisir une option</div>
					</div>

					<div className="form-row text-right mt-4 mx-auto justify-content-end">
						<button
							type="button"
							className="btn btn-light text-muted px-3 mr-auto"
							onClick={() => {
								if (referentData.id === "new") {
									removeFromList(referent.id);
								} else {
									toggleEditMode(referentData.id);
								}
							}}>
							Annuler
						</button>
						{referentData.id === "new" ? (
							""
						) : (
							<button type="button" className="btn btn-alert-danger border-none px-3 mr-2" data-toggle="modal" data-target="#deleteReferent">
								Supprimer
							</button>
						)}

						{isLoading.includes(loadings.UPDATING_REFERENT) || isLoading.includes(loadings.CREATING_REFERENT) ? (
							<button type="button" className="btn btn-info loading-btn show">
								Sauvegarder<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
							</button>
						) : (
							<button
								type="button"
								className="btn btn-info"
								onClick={async (event) => {
									event.preventDefault();
									let internationalPhoneNumberReferent = null;
									// Check if phone number is actually entered (not just empty or whitespace)
									const hasPhoneNumber = referentData.phoneNumber && referentData.phoneNumber.trim() !== "";
									
									if (hasPhoneNumber) {
										internationalPhoneNumberReferent = parsePhoneNumber(referentData.phoneNumber, referentData.phoneCountry);
										if (R.isNil(internationalPhoneNumberReferent) || !internationalPhoneNumberReferent.isValid()) {
											document.getElementById("phone" + referentId).setCustomValidity("Le numéro de téléphone n'est pas valide.");
										}
									}

									// For non-main representatives, if only country code is filled (no actual phone number), send null
									let phoneNumberToSend = null;
									if (referentData.isMainRepresentative || hasPhoneNumber) {
										phoneNumberToSend = R.isNil(internationalPhoneNumberReferent) ? "" : internationalPhoneNumberReferent.number;
									}

									if (referentForm.current.checkValidity()) {
										if (referentData.id === "new") {
											dispatch(createUserRepresentativeForUserId(userId, { ...referentData, asYouType: null, userId: userId, phoneNumber: phoneNumberToSend }));
											//removeFromList(referent.id)
										} else {
											dispatch(updateUserRepresentativeForUserId(userId, { ...referentData, asYouType: null, userId: userId, phoneNumber: phoneNumberToSend })).then(() => toggleEditMode(referentData.id));
										}
									}
									referentForm.current.classList.add("was-validated");
									setWasValidated(true);
								}}>
								Sauvegarder
							</button>
						)}
					</div>
				</form>
				<DeleteModal referent={referentData} deleteReferent={() => dispatch(deleteUserRepresentativeForUserId(userId, referentData.id))} isLoading={isLoading} />
			</div>
		);
}